import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { addDays, format } from 'date-fns';
import { Check, Package, ShieldCheck, Truck, Home } from 'lucide-react';
import { Button } from '../components/Button';
import { usePlatform } from '../contexts/PlatformContext';
export function Confirmed() {
  const {
    order,
    packPills
  } = usePlatform();
  const navigate = useNavigate();
  if (!order) return <Navigate to="/review" replace data-id="element-189" data-mp="3088rlq40dj2x" />;
  const d = (n: number) => format(addDays(order.placedAt, n), 'EEE d MMM');
  const stages = [{
    icon: Check,
    label: 'Order placed',
    date: d(0),
    state: 'done'
  }, {
    icon: ShieldCheck,
    label: 'Doctor verification',
    date: 'Within 24 hours',
    state: 'active'
  }, {
    icon: Package,
    label: 'Packed into daily sachets',
    date: d(2),
    state: 'upcoming'
  }, {
    icon: Truck,
    label: 'Shipped',
    date: d(3),
    state: 'upcoming'
  }, {
    icon: Home,
    label: 'Delivered',
    date: d(5),
    state: 'upcoming'
  }];
  return <div className="mx-auto max-w-2xl text-center" data-id="element-190" data-mp="3h3v4yr60qr2g">
      <motion.span initial={{
      scale: 0.6,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 18
    }} className="mx-auto flex size-14 items-center justify-center rounded-full bg-[#9b8cf0] text-[#0f1017]" data-id="element-191" data-mp="3h6r1qc64r9pb">
        <Check className="size-7" data-id="element-192" data-mp="3m1mvphuxg752" />
      </motion.span>
      <h1 className="mt-6 text-3xl font-medium tracking-tight md:text-4xl" data-id="element-193" data-mp="2yf830hj52ht3">Your pack is on its way</h1>
      <p className="mt-3 text-muted-foreground" data-id="element-194" data-mp="2tg4uuo7v3vgw">
        Order <span className="font-mono text-foreground" data-id="element-195" data-mp="376gpouvu08bq">{order.id}</span> · {packPills.length} supplements · 30 days
      </p>

      <ol className="mt-12 space-y-0 rounded-2xl border border-white/10 bg-white/[0.02] p-6 text-left" data-id="element-196" data-mp="32f8epueusewg">
        {stages.map((s, i) => <li key={s.label} className="relative flex gap-4 pb-6 last:pb-0" data-id="element-197" data-mp="2eomlvadf7171" data-mpi={i}>
            {i < stages.length - 1 && <span className={`absolute left-4 top-9 h-[calc(100%-2.25rem)] w-px ${s.state === 'done' ? 'bg-[#9b8cf0]' : 'bg-white/10'}`} aria-hidden="true" data-id="element-198" data-mp="2amhrg9f5e0jc" />}
            <span className={`flex size-8 shrink-0 items-center justify-center rounded-full ${s.state === 'done' ? 'bg-[#9b8cf0] text-[#0f1017]' : s.state === 'active' ? 'border border-[#9b8cf0] text-[#c4baff]' : 'border border-white/15 text-muted-foreground'}`} data-id="element-199" data-mp="ilq4lev1tc4i">
              <s.icon className="size-4" data-id="element-200" data-mp="3vucke222x3q9" />
            </span>
            <div className="pt-1" data-id="element-201" data-mp="4mqjgh6qvfd3">
              <p className={s.state === 'upcoming' ? 'text-muted-foreground' : 'font-medium'} data-id="element-202" data-mp="4mgoef6uei0j">{s.label}</p>
              <p className="text-sm text-muted-foreground" data-id="element-203" data-mp="9nxqge12caip">{s.date}</p>
            </div>
          </li>)}
      </ol>

      <div className="mt-8 flex justify-center gap-3" data-id="element-204" data-mp="1g4rlndydgan9">
        <Button variant="outline" onClick={() => navigate(`/orders/${order.id}`)} data-id="element-205" data-mp="1l0gqnwt5ujqy">View order</Button>
        <Button className="bg-[#9b8cf0] text-[#0f1017] hover:bg-[#b0a4f5]" onClick={() => navigate('/plan')} data-id="element-206" data-mp="35iiw5vapl0ge">
          Adjust next month
        </Button>
      </div>
    </div>;
}